import nfetch from "@/utils/events/nfetch";

export default class SNGPCProdutoSobraService {
    public async combo(): Promise<Response> {
        return nfetch("/Sngpc/produtos-com-sobra", {
            credentials: "same-origin",
        });
    }
}
